module.exports = __webpack_public_path__ + "img/creator-(4).ddb988df.png";